import { Box, ListItem, ListItemButton, ListItemText } from "@mui/material";
import { CSSProperties, useContext, useState } from "react";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { useNavigate } from "react-router-dom";
import { LayoutsConfig, MainContext } from "../context/MainContextProvider";

export type AsideMenuAccordionDaashboardItemProps = {
  title: string;
  icon: (style: CSSProperties) => React.ReactNode;
  route?: string;
  cantShow?: boolean;
  disabled?: boolean;
  isShrunken: boolean;
  isMobile?: boolean;
  children: React.ReactNode;
};
export function AsideMenuAccordionDashboardItem(
  props: AsideMenuAccordionDaashboardItemProps
) {
  const { title, icon, route, disabled, isShrunken, isMobile, children } =
    props;
  const navigate = useNavigate();
  const path = window.location.pathname;
  //
  const [isActive, setIsActive] = useState(
    route ? path.includes(route) : false
  );
  const { theme, layout } = useContext(MainContext);
  const iconStyle: CSSProperties = {
    color: isActive ? layout == LayoutsConfig.LayoutTwo ? "#E9E9E9" : theme.primaryTextColor : "#8F969E",
    width: "1.5rem",
    height: "1.5rem",
    marginRight: layout == LayoutsConfig.LayoutOne ? "8px" : undefined,
  };

  const toggleAccordion = () => {
    setIsActive((prevIsActive) => !prevIsActive);
  };
  return (
    <>
      <ListItem disablePadding>
        <ListItemButton
          disabled={disabled}
          sx={{
            borderRadius: "10px",
            paddingLeft: layout == LayoutsConfig.LayoutTwo ? "8px" : undefined,
            paddingRight: layout == LayoutsConfig.LayoutTwo ? undefined : "16px"
          }}
          onClick={() => {
            if (!isActive || path !== route) {
              route && navigate(route);
            }

            toggleAccordion();
          }}
        >
          <Box
            sx={{
              flexDirection: "row",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: isShrunken ? undefined : "100%",
            }}
          >
            <Box
              sx={{ direction: "row", display: "flex" }}
              className={isShrunken ? "" : "pe-2"}
            >
              {icon(iconStyle)}
              <Box
                sx={{
                  flexDirection: "row",
                  display: isShrunken ? "none" : "flex",
                  alignItems: "center",
                  marginLeft: layout == LayoutsConfig.LayoutTwo ? "8px" : undefined
                }}
              >
                <ListItemText
                  primaryTypographyProps={{
                    sx: {
                      fontSize: isMobile ? "1.125rem" : "14px",
                      color: isActive ? layout == LayoutsConfig.LayoutTwo ? "#E9E9E9" : theme.primaryTextColor : "#8F969E",
                    },
                  }}
                  primary={title}
                />
              </Box>
            </Box>
            <Box display={isShrunken ? "none" : ""}>
              <KeyboardArrowRightIcon
                sx={{
                  marginRight: "10px",
                  height: "24px",
                  width: "24px",
                  cursor: "pointer",
                  transform: isActive ? "rotate(90deg)" : "rotate(0deg)",
                  transition: "transform 0.1s ease-in-out",
                  color: isActive ? layout == LayoutsConfig.LayoutTwo ? "#E9E9E9" : theme.primaryTextColor : "#8F969E",
                }}
              />
            </Box>
          </Box>
        </ListItemButton>
      </ListItem>
      {isActive && children}
    </>
  );
}
